import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/illustrations/map_pin.svg'


const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-4 mpc-location mx-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            src: _imports_0,
            height: "44px",
            width: "44px",
            class: "mx-auto"
          }),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "token-text-h4 mb-2 text-center" }, " Location ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "token-text-regular mb-6 text-center" }, " Almost done, do you need to be hosted in a specific country? ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CountrySelector, { onSelect: _ctx.onCountrySelect }, null, 8, ["onSelect"]),
            _createElementVNode("div", {
              class: "token-text-medium token-text-color-brand mt-4 text-center cursor-pointer text-decoration-underline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:selectedCountry', null)))
            }, " No, I don’t need a specific country ")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}